import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import {
  shipsApi,
  authApi,
  userApi,
  facadeApi,
  fleetApi,
  marineInfrastructureApi,
  targetApi,
  leadApi,
  searchApi,
  weatherApi,
  photoApi,
} from '../api';

import userSlice from '../utils/userSlice';
import tableSlice from '../utils/tableSlice';


import searchSlice from '../utils/searchSlice';
import facadeReducer from '../utils/facadeReducer';
import marineInfrastructureReducer from 'app/utils/marineInfrastructureReducer';
import selectedTargetsSlice from 'app/utils/selectedTargetsSlice';
import mapStateSlice from 'app/utils/mapStateSlice';
import weatherReducer from 'app/utils/weatherReducer';
import photoReducer from 'app/utils/photoReducer';

export const store = configureStore({
  reducer: {
    [shipsApi.reducerPath]: shipsApi.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [userApi.reducerPath]: userApi.reducer,
    [searchApi.reducerPath]: searchApi.reducer,
    [facadeApi.reducerPath]: facadeApi.reducer,
    [fleetApi.reducerPath]: fleetApi.reducer,
    [marineInfrastructureApi.reducerPath]: marineInfrastructureApi.reducer,
    [targetApi.reducerPath]: targetApi.reducer,
    [leadApi.reducerPath]: leadApi.reducer,
    [weatherApi.reducerPath]: weatherApi.reducer,
    [photoApi.reducerPath]: photoApi.reducer,

    userSlice: userSlice,
    searchSlice: searchSlice,
    tableSlice: tableSlice,
    facadeSlice: facadeReducer,
    marineInfrastructureSlice: marineInfrastructureReducer,
    weatherSlice: weatherReducer,
    photoSlice: photoReducer,

    //deckgl - new store slices
    selectedTargetsSlice: selectedTargetsSlice,
    mapStateSlice: mapStateSlice,
  },
  devTools: process.env.NODE_ENV !== 'production',
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }).concat([
      shipsApi.middleware,
      authApi.middleware,
      userApi.middleware,
      searchApi.middleware,
      facadeApi.middleware,
      fleetApi.middleware,
      marineInfrastructureApi.middleware,
      targetApi.middleware,
      leadApi.middleware,
      weatherApi.middleware,
      photoApi.middleware,
    ]),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

setupListeners(store.dispatch);
